module.exports = __webpack_public_path__ + "static/media/image4.30193487.png";